module.exports = __webpack_public_path__ + "img/ico1_active.443d68b0.png";